import { QueryClient } from "@tanstack/react-query";
import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import { createQuery, useStaticQuery } from "./ultilities/base-query";
import {
  buildCatalogCacheKey,
  invalidateCatalogCache,
} from "./ultilities/catalog-cache-key";

export type MaterialCatalogRecord = {
  code: string;
  type: string;
  name: string;
};

export const MATERIAL_CATALOG_CACHE_KEY = buildCatalogCacheKey("material");

const normalizeValue = (value: string | null | undefined): string => {
  return value?.trim() ?? "";
};

const fetchMaterialCatalog = async (): Promise<MaterialCatalogRecord[]> => {
  const res = await materialBusiness.getLists({
    name: undefined,
    maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
    skipCount: 0,
    sorting: "",
  });

  return (res.items ?? []).map((item) => ({
    code: normalizeValue(item.code),
    type: normalizeValue(item.type),
    name: normalizeValue(item.name),
  }));
};

export const useMaterialCatalogCache = () => {
  return useStaticQuery(MATERIAL_CATALOG_CACHE_KEY, fetchMaterialCatalog);
};

export const prefetchMaterialCatalogCache = async (
  queryClient: QueryClient,
) => {
  await queryClient.prefetchQuery(
    createQuery(MATERIAL_CATALOG_CACHE_KEY, fetchMaterialCatalog, "static"),
  );
};

export const invalidateMaterialCatalogCache = async (
  queryClient: QueryClient,
) => {
  await invalidateCatalogCache(queryClient, "material");
};
